// src/components/GameListV2.js
import React from 'react';
import GameCardV2 from './GameCardV2'; 

function GameListV2({ games, isLoading, isFetchingMore, hasNextPage, onGameClick }) {
    
    if (isLoading && games.length === 0) {
        return (
            <div className="flex justify-center items-center py-32">
                <div className="w-12 h-12 border-4 border-[#FFF5EE] border-t-[#971253] rounded-full animate-spin"></div>
            </div>
        );
    }

    if (!isLoading && games.length === 0) {
        return <div className="text-center font-serif text-2xl text-[#528a89] py-32 italic">Nenhum tomo encontrado na biblioteca.</div>;
    }

    return (
        <div className="max-w-7xl mx-auto py-12">
            {/* O novo Grid: 2 mobile, 3 tablet, 4 desktop, 5 extra-large. Gap generoso. */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 md:gap-8">
                {games.filter(game => game.id_jogo != -1).map(game => (
                    <GameCardV2 
                        key={game.id_jogo} 
                        game={game}
                        onGameClick={onGameClick} 
                    />
                ))}
            </div>

            {/* Infinite Scroll Footer */}
            <div className="py-16 flex justify-center items-center">
                {isFetchingMore && (
                    <div className="w-8 h-8 border-2 border-[#FFF5EE] border-t-[#528a89] rounded-full animate-spin"></div>
                )}
                {!hasNextPage && !isFetchingMore && games.length > 0 && (
                    <div className="flex items-center gap-4 opacity-50">
                        <div className="h-[1px] w-12 bg-[#971253]"></div>
                        <span className="font-serif text-[#971253] italic">Fim do Acervo</span>
                        <div className="h-[1px] w-12 bg-[#971253]"></div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default GameListV2;